(function() {
	Vue.component('nominow-range-slider', {
		model: {
			prop: 'model',
			event: 'change'
		},
		props: {
			model: {
				type: String,
				required: true,
				default: () => ({})
			},
			id: {
				type: String,
				required: true,
				default: 'id'
			},
			data_tag_id: {
				type: String,
				required: true,
				default: 'data_tag_id'
			},
			min: {
				type: Number,
				required: true,
				default: 0
			},
			max: {
				type: Number,
				required: true,
				default: 10
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		data: function() {
			return {};
		},
		template: `
        <div v-bind:class="{'mui-textfield' : (!nomui)}">
            <div class="control field">
                <label class="range-slider">
                    <div class="slider" :data-id="data_tag_id" :id="id" :data-min="min" :data-max="max">
                        <div class="slider-value slider-value-1-js">{{min}}</div>
                        <div class="slider-value slider-value-2-js" style="left: 100%">{{max}}</div>
                        <span class="min-value slider-value">{{min}}</span>
                        <span class="max-value slider-value">{{max}}</span>
                    </div>					
                </label>
            </div>
        </div>
        `,
		mounted: function() {
			console.log('model:', this.model);
			const self = this;

			const obj = jQuery(`#${self.id}`);
			const sId = `#${self.id}`;
			const min = self.min;
			const max = self.max;

			obj.slider({
				range: true,
				min: min,
				max: max,
				step: 1,
				values: [min, max],

				slide: function(event, ui) {
					$(`${sId} .slider-value-1-js`).html(ui.values[0]);
					$(`${sId} .slider-value-2-js`).html(ui.values[1]);

					const $sliderpos = $(`${sId} .ui-slider-handle:first`).css('left');
					const $sliderpos2 = $(`${sId} .ui-slider-handle:eq(1)`).css('left');

					$(`${sId} .slider-value-1-js`).css({ left: $sliderpos });
					$(`${sId} .slider-value-2-js`).css({ left: $sliderpos2 });
				},
				stop: function() {
					const $sliderpos = $(`${sId} .ui-slider-handle:first`).css('left');
					const $sliderpos2 = $(`${sId} .ui-slider-handle:eq(1)`).css('left');

					$(`${sId} .slider-value-1-js`).css({ left: $sliderpos });
					$(`${sId} .slider-value-2-js`).css({ left: $sliderpos2 });

					self.model.value = $(sId).slider('option', 'values')[0];
					self.model.maxvalue = $(sId).slider('option', 'values')[1];
				}
			});
		}
	});
})();
